import axios from "axios";

const URL = {
    base: '/api/cdk/version/v1/',
}

const HEADERS = {
    "Content-Type": "application/json"
}

const VersionService = {
    getVersion: async () => {

        try {

            const response = await axios.get(`${URL.base}`, {headers: HEADERS});
            const version = response.data;

            return version;

        } catch (e) {
            console.error('An error has occurred while trying to load the version', e);
            return {hasError: true};
        }

    }
}

export default VersionService;